import * as React from "react";

import {SignupStage1 as IMG_1} from "./SignupImage1";
import {SignupImage2 as IMG_2} from "./SignupImage2";

function makeRenderImage(imageNum: number) {
    const newImages = {1: IMG_1, 2: IMG_2};

    return (): React.ReactElement => {
        const componentsDict = newImages;
        const Component = componentsDict[imageNum];

        return <Component />;
    };
}

export const SignupImage1: React.FC = makeRenderImage(1);
export const SignupImage2: React.FC = makeRenderImage(2);
